var map = {
	"./1.png": 16,
	"./2.png": 17,
	"./3.png": 18,
	"./4.png": 19,
	"./5.png": 20,
	"./6.png": 21,
	"./7.png": 22,
	"./8.png": 23,
	"./9.png": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;